import { toast } from 'react-toastify';

const success = (str, opt = {}) => {
  toast.success(str, opt);
};

const error = (str, opt = {}) => {
  toast.error(str, opt);
};

const info = (str, opt = {}) => {
  toast.info(str, opt);
};

const remove = () => {
  toast.dismiss();
};

export const snackbar = { success, error, info, remove };
